export enum ApiErrorCode {
	TOO_MANY_REQUESTS = 429,
	TOKEN_EXPIRED = 1050,
	TOKEN_MALFORMED = 1051,
	DISABLED_ACCOUNT = 1052,
	UNKNOWN_REVOKED_TOKEN = 1053,
	TOKEN_INVALID = 1060,
	OKTA_USER_CANNOT_RESET_PASSWORD = 1091,
	OKTA_USER_CANNOT_UPDATE_PASSWORD = 1092,
	PASSWORD_EXPIRED = 1205,
	OKTA_BASIC_LOGIN_NOT_AVAILABLE = 1206,
	NO_DATA_BEFORE_24H = 1424,
	NOT_FOUND_UPC = 1427,
	PROVIDER_NEEDED = 1428,
	INVALID_UPC = 1429,
	CANNOT_DELETE_ACCOUNT_ADMIN_WITH_USERS = 1536,
	MISSING_PARAMETER_SIGNUP = 1548,
	NO_CLAIM_REQUESTS = 1600,
	MISSING_PARAMETER_CLAIM_ARTIST = 1606,
	INVALID_UPC_CLAIM_ARTIST_MANAGER = 1607,
	ARTIST_ALREADY_CLAIMED_BY_THIS_USER = 1610,
	CLAIM_DELETE_NOT_FOUND = 1611,
	CLAIM_DELETE_NOT_YOURS = 1612,
	CLAIM_DELETE_NOT_IN_PROGRESS = 1613,
	CLAIM_REQUEST_EMPTY_MANAGER = 1615,
	CLAIM_REQUEST_INVALID_PARAMETER_MANAGER = 1616,
	CLAIM_REQUEST_INVALID_UPC = 1617,
	MANAGER_ALREADY_CLAIMED_THIS_ARTIST = 1618,
	CANNOT_CLAIM_USER_ALREADY_HAS_ACCESS = 1622,
	CLAIM_REQUEST_EMPTY_LABEL = 1637,
	CLAIM_REQUEST_INVALID_PARAMETER_LABEL = 1638,
	INVALID_UPC_CLAIM_LABEL = 1639,
	EMAIL_ALREADY_USED_SIGNUP = 1640,
	MISSING_PARAMETER_CREATEACCOUNT = 1642,
	EMAIL_ALREADY_USED_CREATEPASSWORD = 1644,
	PASSWORD_NOT_STRONG_ENOUGH = 1645,
	OKTA_ACCOUNT_CANNOT_BE_DELETED_OR_UPDATED = 1649,
	LABEL_ALREADY_HAS_ACCESS = 1660,
	ALREADY_CLAIMED_PROVIDER = 1665,
	NOT_MATCHING_UPC_PROVIDER = 1666,
	MISSING_PARAMETER_CLAIM_PROVIDER = 1668,
	INVALID_UPC_PROVIDER = 1669,
	PITCH_FORBIDDEN_ACCESS = 1700,
	PITCH_EMPTY_BODY = 1701,
	PITCH_INVALID_STAKEHOLDER_TYPE = 1702,
	PITCH_BODY_PARAMETER_MISSING = 1703,
	PITCH_UPC_FORMAT_INVALID = 1704,
	PITCH_PRIORITY_INVALID = 1705,
	PITCHES_CREATE_WITH_SAME_UPC_ALREADY_TARGET_THIS_MARKET = 1706,
	PITCH_LABEL_NOT_PART_OF_YOUR_ACCESS = 1707,
	PITCH_EDIT_FORBIDDEN_ACCESS = 1708,
	PITCHES_FILTERS_EDITO_TEAM_DOES_NOT_EXISTS = 1710,
	PITCH_IS_NOT_YOURS_EDIT = 1711,
	PITCH_LINK_INVALID_CREATE = 1712,
	PITCH_24H_BEFORE_RELEASE_EDIT = 1713,
	PITCH_CANNOT_SET_PASSED_DATE_FOR_RELEASE = 1714,
	PITCH_CANNOT_SET_NEW_RELEASE_DATE_TO_24H = 1715,
	PITCHES_FILTERS_ACCESS_FORBIDDEN = 1716,
	PITCHES_FILTERS_USER_IS_NOT_AM_USER = 1717,
	PITCHES_FILTERS_INVALID_STAKEHOLDER_TYPE = 1718,
	PITCH_DELETE_FORBIDDEN_ACCESS = 1719,
	PITCH_IS_NOT_YOURS_DELETE = 1730,
	PITCH_LINK_INVALID_EDIT = 1731,
	PITCH_24H_BEFORE_RELEASE_DELETE = 1732,
	PITCH_DOES_NOT_BELONG_TO_YOU = 1743,
	SUB_LABEL_ACCESS_DENIED = 1750,
	PITCHES_IMPORT_FORBIDDEN_ACCESS = 1760,
	PITCHES_IMPORT_FILE_MISSING = 1761,
	PITCHES_IMPORT_UPLOADER_ERROR = 1762,
	PITCHES_IMPORT_INVALID_STAKEHOLDER_TYPE = 1763,
	PITCHES_IMPORT_MISSING_PARAMETER = 1764,
	PITCHES_IMPORT_INVALID_UPC = 1765,
	PITCHES_IMPORT_INVALID_PRIORITY = 1766,
	PITCHES_IMPORT_RELEASE_ALREADY_PITCHED = 1767,
	PITCHES_IMPORT_UNAUTHORIZED_LABEL = 1768,
	PITCHES_IMPORT_LABEL_NOT_FOUND = 1769,
	PITCHES_IMPORT_PROVIDER_NOT_FOUND = 1770,
	PITCH_ISRC_INVALID = 1772,
	PITCH_WRONG_ARTIST_GENDER = 1773,
	PITCHES_IMPORT_INVALID_LISTENING_LINK = 1774,
	PITCHES_IMPORT_FILE_TOO_BIG = 1775,
	PITCHES_IMPORT_RELEASE_DATE_PAST = 1776,
	PITCHES_IMPORT_RELEASE_DATE_WRONG_FORMAT = 1777,
	PITCHES_IMPORT_INVALID_CONFIG = 1778,
	PITCHES_IMPORT_INVALID_TYPE = 1779,
	PITCHES_IMPORT_INVALID_GENRE = 1780,
	PITCHES_IMPORT_INVALID_EDITO_TEAM = 1781,
	PITCH_GENRE_INVALID = 1784,
	PITCHES_FILTERS_PRIORITY_DOES_NOT_EXISTS = 1786,
	PITCHES_FILTERS_GENRE_DOES_NOT_EXISTS = 1787,
	PITCHES_FILTERS_STATUS_DOES_NOT_EXISTS = 1788,
	PITCHES_IMPORT_INVALID_TEMPLATE_FORMAT = 1789,
	PITCHES_FILTERS_DATE_INVALID = 1790,
	PITCHES_FILTERS_SORT_INVALID = 1791,
	PITCHES_FILTERS_FORBIDDEN_ACCESS = 1795,
	PITCH_DOES_NOT_EXISTS = 1796,
	PITCH_DELETED = 1797,
	PITCH_EDIT_ISRC_INVALID = 1798,
	PITCHES_EDIT_WITH_SAME_UPC_ALREADY_TARGET_THIS_MARKET = 1799,
	PITCH_IMPORT_INVALID_DATE_FORMAT = 1830,
	COPYRIGHT_CLAIM_NOT_VALID_EMAIL = 1873,
	COPYRIGHT_CLAIM_NOT_VALID_FIRSTNAME = 1874,
	COPYRIGHT_CLAIM_NOT_VALID_LASTNAME = 1875,
	COPYRIGHT_CLAIM_NOT_VALID_COMPANY_NAME = 1876,
	COPYRIGHT_CLAIM_NOT_VALID_ADDRESS = 1877,
	COPYRIGHT_CLAIM_NOT_VALID_PHONE_NUMBER = 1878,
	COPYRIGHT_CLAIM_NOT_VALID_CLAIM_TYPE = 1879,
	COPYRIGHT_CLAIM_NOT_VALID_CLAIM_CONTENT_TYPE = 1880,
	COPYRIGHT_CLAIM_NOT_VALID_CLAIM_NATURE = 1881,
	COPYRIGHT_CLAIM_NOT_VALID_ORIGINAL_CONTENT_LINKS = 1883,
	COPYRIGHT_CLAIM_NOT_VALID_REASON = 1884,
	COPYRIGHT_CLAIM_NOT_VALID_RIGHTSHOLDER_RELATIONSHIP = 1885,
	COPYRIGHT_CLAIM_NOT_VALID_RIGHTSHOLDER_NAME = 1886,
	COPYRIGHT_CLAIM_NOT_VALID_RIGHTSHOLDER_EMAIL = 1887,
	COPYRIGHT_CLAIM_NOT_VALID_AGENT_TO_RIGHTSHOLDER_RELATIONSHIP = 1888,
	COPYRIGHT_CLAIM_NOT_VALID_COUNTRIES = 1889,
	COPYRIGHT_CLAIM_CANNOT_DENY_CLOSED_CLAIM = 1890,
	COPYRIGHT_CLAIM_NO_CASE_ON_THIS_CLAIM = 1891,
	COPYRIGHT_CLAIM_MISSING_FEEDBACK_SOLVE = 1892,
	COPYRIGHT_CLAIM_MISSING_COMMENT_SOLVE = 1893,
	COPYRIGHT_CLAIM_CANNOT_SOLVE_CLOSED_CLAIM = 1894,
	COPYRIGHT_CLAIM_SOLVE_INVALID_STATUS = 1895,
	COPYRIGHT_CLAIM_NO_CONTENT_ON_THIS_CLAIM = 1896,
	COPYRIGHT_CLAIM_MISSING_EMAIL_ON_EDITION = 1897,
	COPYRIGHT_CLAIM_INVALID_EMAIL_ON_EDITION = 1898,
	COPYRIGHT_CLAIM_CANNOT_ACKNOWLEDGE_CLAIM_AT_LEAST_ONE_EMAIL_MISSING = 1899,
	PITCHES_TOO_MUCH_FILTERS = 1903,
	CAMPAIGN_BUDGET_TOO_LOW = 1943,
	CAMPAIGN_CREATE_BUDGET_TOO_LOW = 1959,
	CAMPAIGN_48H_DELAY = 1978,
	CAMPAIGN_EDIT_BUDGET_TOO_LOW = 1980,
	CAMPAIGN_ALREADY_SET_FOR_THIS_UPC = 1988,
	CAMPAIGN_ARTIST_TOO_SMALL = 1989,
	COPYRIGHT_CLAIMS_WRONG_PRIVILEGES = 1870,
	COPYRIGHT_CLAIMS_FORBIDDEN_ACCESS_DASHBOARD = 1871,
	COPYRIGHT_CLAIM_NOT_FOUND = 1872,
	COPYRIGHT_CLAIM_PENDING_CLAIM_SOLVING = 1882,
}
